<template>
	<b-card-body>
		<div class="row">
			<planned-level-stats-class :level="level" />
			<planned-level-stats-increases :level="level" />
			<planned-level-stats-spells-daily :level="level" />
			<planned-level-stats-spells-known :level="level" />
		</div>
	</b-card-body>
</template>

<script>
import PlannedLevelStatsClass from '@/components/planning/PlannedLevelStatsClass.vue'
import PlannedLevelStatsIncreases from '@/components/planning/PlannedLevelStatsIncreases.vue'
import PlannedLevelStatsSpellsDaily from '@/components/planning/PlannedLevelStatsSpellsDaily.vue'
import PlannedLevelStatsSpellsKnown from '@/components/planning/PlannedLevelStatsSpellsKnown.vue'


export default {
	props: [
		'level'
	],
	components: {
		PlannedLevelStatsClass,
		PlannedLevelStatsIncreases,
		PlannedLevelStatsSpellsDaily,
		PlannedLevelStatsSpellsKnown,
	}
}
</script>

<style scoped>

</style>